(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/intersection', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/intersection'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.intersection, global.convert);
    global.intersection = mod.exports;
  }
})(this, function (exports, _intersection2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.intersection = undefined;

  var _intersection3 = _interopRequireDefault(_intersection2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces by an array of unique values that are included in th former array and all given arrays.
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {...Array} [arrays] The arrays to inspect.
   * @return {Object} Returns the updated object.
   * @example intersection({ nested: { prop: [1, 2] } }, 'nested.prop', [2, 3]) // => { nested: { prop: [2] } }
   * @see {@link https://lodash.com/docs#intersection|lodash.intersection} for more information.
   * @since 0.3.0
   */
  var intersection = (0, _convert.convert)(_intersection3.default);
  exports.intersection = intersection;
  exports.default = intersection;
});